import './CardB.scss'

const CardB = () => {
    return (
      <>
        <div className="card-b">
            <div className="textContentB">
                <h3>Always Protected</h3>
                <span>Shopping with PIE is safer with Buyer Protection, 24/7 anti-fraud monitoring and world class security</span>
            </div>
            <div className="security">
                <img src="./images/shield.png" alt="" />
                <img src="./images/touch.png" alt="" />
            </div>
        </div>    
    </>
    )
}

export default CardB
